import { motion } from "framer-motion";
import RevealLine from "./RevealLine";

const STATS = [
  ["3B+", "Spotify streams"],
  ["36M", "Monthly listeners"],
  ["Hï Ibiza", "Resident"],
];

const SpotifySection = () => (
  <section data-testid="spotify-section" className="relative bg-night px-5 sm:px-10 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl grid lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16 items-center">
      <div>
        <RevealLine inView className="eyebrow">The Sound</RevealLine>
        <h2 className="mt-5 font-display font-bold uppercase leading-[1.05] tracking-tight text-2xl sm:text-3xl lg:text-4xl text-bone">
          <RevealLine inView delay={0.1}>Latin heat.</RevealLine>
          <RevealLine inView delay={0.2} className="text-coral">Underground house.</RevealLine>
        </h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-6 max-w-md text-sand text-sm sm:text-base leading-relaxed"
          data-testid="about-copy"
        >
          The man behind “I Adore You” and “Morenita” — sun-drenched Latin house, from Ibiza terraces to one night
          in Kolkata. Press play.
        </motion.p>

        <motion.dl
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-8 grid grid-cols-3 gap-4 max-w-md"
          data-testid="artist-stats"
        >
          {STATS.map(([value, label]) => (
            <div key={label} className="border-t border-coral/40 pt-3">
              <dt className="sr-only">{label}</dt>
              <dd className="font-display font-bold text-lg sm:text-xl text-bone leading-none">{value}</dd>
              <dd className="mt-2 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-ash">{label}</dd>
            </div>
          ))}
        </motion.dl>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 0.15 }}
      >
        <iframe
          data-testid="spotify-artist-embed"
          title="HUGEL on Spotify"
          style={{ borderRadius: 12 }}
          src="https://open.spotify.com/embed/artist/5PlfkPxwCpRRWQJBxCa0By?utm_source=generator&theme=0&si=7502c9f5edd14a2a"
          width="100%"
          height="352"
          frameBorder="0"
          allowFullScreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
      </motion.div>
    </div>
  </section>
);

export default SpotifySection;
